import { l, lreplace } from '@utils/toolbox';
import { extraItem } from './extra-item';

const Item = {
	id: '',				// id of the item
	selected: false,	// is the default selected
	forwardURL: '',		// main cta url
	mainImg: '',		// main image to display
	display: {
		price: '',
		sellpoint: [
			{
				icon: '',
				text: ''
			}
		]
	},					// offer display side by side to the main image
	extraInfo: {},		// any extra offer
	extraItems: [],		// extra alternative offers/links
	options: {}		// anything else for style display goes here
};

/**
 * Kallebakom item
 * @param {Item} item
 * @param {String} airportName
 * @returns html String
 *
 * Example of some of the translation strings in this file:
 * (here for development purposes)
 * 	'kallebakom.rentalcar.headline'
 * 	'kallebakom.rentalcar.alternatives'
 * 	'kallebakom.rentalcar.cta'
 */
export const item = (item, airportName) => {
	if (!item) {
		return;
	}

	return `
<div class="kallebakom__item ${item.selected ? 'active' : ''}" data-kalleview="${item.id}">
	${item.options?.svgOnTab ? `<img class="kallebakom__multimobilemobile-logo" src="/static/v${js_params.version}/images/global/thirdparty_${item.id}.svg" />` : ``}
	<img class="kallebakom__multimobile-image" src="/static/v${js_params.version}/images/kallebakom/${item.id}.png" />
		${(item.options?.cityOnlyInHeader && js_params.to?.city)
		? `<h1 class="kallebakom__title">${lreplace('kallebakom.' + item.id + '.headline', { city: js_params.to?.city, country: js_params.to?.country })}</h1>`
		: `<h1 class="kallebakom__title">${lreplace('kallebakom.' + item.id + '.headline', { airport: airportName, city: item.options?.cityInTitle ? item.options?.cityInTitle : '' })} </h1>`
		}
	<div class="kallebakom__multimobile-content">

		${item.options?.hugeTitle
		? `<h1 class="kallebakom__huge-title">${item.options?.hugeTitle}</h1>`
		: ''}

		${item.id === 'arlandaexpress'
		? `<img class="kallebakom__arlanda--arrow-first" src="/static/v${js_params.version}/images/kallebakom/arrow_arlanda.svg" />`
		: ''}

		${item.forwardURL
			? `<a href="${item.forwardURL}" target="_blank" class="kallebakom__item-content link-item" role="button" data-value="1" data-kalleid="${item.id}">
			${item.mainImg ? `<div class="kallebakom__item-content--image"><img src="${item.mainImg}" loading="lazy" /></div>` : ``}
			${item.display ? `
			<div class="kallebakom__display">
				${item.display?.price ? `<span class='kallebakom__display__price'>${item.display.price}</span>` : ``}
				${item.display?.sellpoint?.map(s => `<span>${s.icon ? `<i class='icon icon-${s.icon}'></i>` : ''} ${s.text}</span>`).join('')}
			</div>` : ``}
		</a>` : ''}

		${item.id === 'arlandaexpress'
		? `<img class="kallebakom__arlanda--arrow-last" src="/static/v${js_params.version}/images/kallebakom/arrow_arlanda.svg" />`
		: ''}


		${item.id === 'arlandaexpress'
		? `
		<div class="kallebakom__arlanda--description">
			<img class="kallebakom__arlanda--arrow-blacks" src="/static/v${js_params.version}/images/kallebakom/arrow_arlanda--black.svg" />
			<span>${l('kallebakom.arlandaexpress.sellPointBlackArrows')}</span>
		</div>
		<img class="kallebakom__arlanda--logo" src="/static/v${js_params.version}/images/kallebakom/arlandaexpress.svg" />`
		: ''}
		
		${item.extraInfo?.copyCodeInput
		? `<div class="kallebakom-modal--inputbox discountBox">
			<label for="flygersorForexDiscount" class="share-modal--inputlabel">${l('kallebakom.auxiliar.campaigncode')}</label>
			<input type="text" name="flygersorForexDiscount" id="flygersorForexDiscount" class="share-modal--input" value="${item.extraInfo.copyCodeInput}" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" tabindex="0">
			<button class="abBtn--blueWhite abBtn abBtn--flex copyBtn" data-action="copyDiscount">${l('kallebakom.auxiliar.copy')}</button>
		</div>`
		: ''}

		${item.extraItems?.length
		? `<div class="kallebakom__alternatives">
			<div class="kallebakom__other">
				<p>${lreplace('kallebakom.' + item.id + '.alternatives', { carCount: item.extraItems.length, country: js_params.to?.country })}</p>
			</div>
			<ul class="kallebakom__additional">${item.extraItems.map((extraI, i) => extraItem(extraI, item.id, i)).join('')}</ul>
		</div>`
		: ''}

		${item.extraInfo?.rentalAffiliates
		? `<ul class="kallebakom__affiliates">
			<li><img class="kallebakom__affiliates--image" src="/static/v${js_params.version}/images/logos_carrental/budget.svg" /></li>
			<li><img class="kallebakom__affiliates--image" src="/static/v${js_params.version}/images/logos_carrental/sixt.svg" /></li>
			<li><img class="kallebakom__affiliates--image" src="/static/v${js_params.version}/images/logos_carrental/hertz.svg" /></li>
			<li><img class="kallebakom__affiliates--image" src="/static/v${js_params.version}/images/logos_carrental/alamo.svg" /></li>
			<li><img class="kallebakom__affiliates--image" src="/static/v${js_params.version}/images/logos_carrental/avis.svg" /></li>
		</ul>`
		: ''}
		
		<div class="link-item abBtn abBtn--blueWhite abBtn--flex kallebakom_cta" data-value="0" data-url=${item.forwardURL} data-kalleid="${item.id}">
		${l('kallebakom.' + item.id + '.cta')}
		</div>
	</div>
</div>
	`;
};
